import React from 'react'
import Button from "../../Button";
import {ChevronRightIcon, PauseIcon, PlayIcon, StopIcon, ChevronLeftIcon, RewindIcon} from "@heroicons/react/solid";

// Types ----

type PlaybackControlProps = {
  text: string
  playbackSpeedLabel: string
  onStartPlayback: () => void
  onPausePlayback: () => void
  onStopPlayback: () => void
  onSkipBackward: () => void
  onSkipForward: () => void
  onRewind: () => void
  onCyclePlaybackSpeed: () => void
  isReady?: boolean
  isPlaying?: boolean
  isStart?: boolean
  isEnd?: boolean
}

// Component ----

function PlaybackControl({
  text = '',
  playbackSpeedLabel = '',
  onStartPlayback,
  onPausePlayback,
  onStopPlayback,
  onSkipBackward,
  onSkipForward,
  onRewind,
  onCyclePlaybackSpeed,
  isReady = false,
  isPlaying = false,
  isStart = true,
  isEnd = false,
}: PlaybackControlProps) {

  function startPlayback() { onStartPlayback?.()}
  function pausePlayback() { onPausePlayback?.()}
  function stopPlayback() { onStopPlayback?.()}
  function skipBackward() { onSkipBackward?.()}
  function skipForward() { onSkipForward?.()}
  function rewind() { onRewind?.() }
  function cyclePlaybackSpeed() { onCyclePlaybackSpeed?.()}

  return (
    <div className={`flex flex-col gap-2 absolute left-[8px] top-[8px] bg-white rounded-md p-2 shadow-border`}>
      <p className='px-3 py-2 text-sm font-medium text-gray-800 text-center'>
        {text}
      </p>

      <div className='flex gap-2'>
        {!isPlaying &&
          <Button size={Button.sizes.TINY} color={Button.colors.WHITE} onClick={startPlayback} title={'Play'} disabled={!isReady || isEnd}>
            <PlayIcon className=' w-5 h-5' />
            <span className='sr-only'>{'Play'}</span>
          </Button>
        }

        {isPlaying &&
          <Button size={Button.sizes.TINY} color={Button.colors.WHITE} onClick={pausePlayback} title={'Pause'}>
            <PauseIcon className=' w-5 h-5' />
            <span className='sr-only'>{'Pause'}</span>
          </Button>
        }

        {(isPlaying || (isStart && !isPlaying)) &&
          <Button size={Button.sizes.TINY} color={Button.colors.WHITE} onClick={stopPlayback} title='Stop' disabled={!isReady || !isPlaying}>
            <StopIcon className=' w-5 h-5' />
            <span className='sr-only'>Stop</span>
          </Button>
        }

        {(!isPlaying && !isStart) &&
          <Button size={Button.sizes.TINY} color={Button.colors.WHITE} onClick={rewind} title='Rewind to start'>
            <RewindIcon className=' w-5 h-5' />
            <span className='sr-only'>Rewind to start</span>
          </Button>
        }

        <Button size={Button.sizes.TINY} color={Button.colors.WHITE} onClick={skipBackward} title='Skip backward' disabled={!isReady || isStart}>
          <ChevronLeftIcon className=' w-5 h-5' />
          <span className='sr-only'>Skip backward</span>
        </Button>

        <Button size={Button.sizes.TINY} color={Button.colors.WHITE} onClick={skipForward} title='Skip forward' disabled={!isReady || isEnd}>
          <ChevronRightIcon className=' w-5 h-5' />
          <span className='sr-only'>Skip forward</span>
        </Button>

        <Button size={Button.sizes.TINY} color={Button.colors.WHITE} onClick={cyclePlaybackSpeed} title='Playback speed' disabled={!isReady}>
          <span className='min-w-[4ch]'>{playbackSpeedLabel}</span>
        </Button>
      </div>
    </div>
  );
}

export {PlaybackControl};